import React, { useState } from "react";
import get from "lodash/get";
import { getIconForUID } from "components/FormerEditor/utils";
import GridCell from "components/GridCell";
import { useIsAuthed } from "utils/selectors";
import Button from "components/Form/fields/Button";
import { BUTTON_TAGS, UI_THEME } from "utils/constants/ui";
import PATHS from "utils/paths";
import IconButton from "components/IconButton";
import SlimCTA from "components/SlimCTA";
import { COLORS } from "utils/styles";
import { getStoreUpgradeFeature, setStoreUpgradeFeature } from "utils/upgrade";
import CheckoutButton from "components/PriceBlocs/Package/CheckoutButton";

const DISMISSED = "dismissed";

const DEFAULT_CLASSES = {
  container: "flex flex-column w-100 ba br2 pa3 hairline-1 relative mb2",
  close: "absolute top-0 right-0 pr3 pt3",
  action: "dib pt3 w-auto"
};

const EntitlementUpgradePrompt = ({
  uid,
  icon,
  header,
  subheader,
  entitlement,
  customClasses,
  component
}) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const alreadyDimissed = Boolean(getStoreUpgradeFeature(uid));
  const [dismissed, setDismissed] = useState(alreadyDimissed);
  const isAuthed = useIsAuthed();
  const Icon = getIconForUID(icon);

  if (dismissed) {
    return null;
  }

  let buttonNode;

  if (isAuthed) {
    buttonNode = (
      <CheckoutButton
        checkout={{ prices: [entitlement.upgrade.price] }}
        theme={UI_THEME.SLIM}
        copy={{ value: "Upgrade" }}
      />
    );
  } else {
    buttonNode = (
      <Button
        copy="Sign up"
        tag={BUTTON_TAGS.LINK}
        href={PATHS.SIGNUP}
        theme={UI_THEME.SLIM}
      />
    );
  }

  const iconProps = {
    iconType: "close",
    iconProps: {
      size: 20
    },
    colors: {
      inactive: COLORS.primary
    },
    onClick: () => {
      setStoreUpgradeFeature(uid, DISMISSED);
      setDismissed(true);
    }
  };

  const upgradeEntitlement = get(entitlement, "upgrade.entitlement");
  const description =
    typeof subheader === "function" ? subheader(upgradeEntitlement) : subheader;

  if (component === UI_THEME.SLIM) {
    return (
      <SlimCTA
        header={header}
        customClasses={{
          container:
            "w-100 flex flex-column flex-row-ns justify-between items-start items-center-ns bg-white pv3 relative",
          header: "f5 fw6",
          subheader: "f6 lh-copy"
        }}
        subheader={description}
      >
        <div className="dib flex flex-row items-center">
          {buttonNode}
          <div className="ml3 pl2 bl hairline-1">
            <IconButton {...iconProps} />
          </div>
        </div>
      </SlimCTA>
    );
  } else {
    return (
      <GridCell
        Icon={Icon}
        customClasses={{
          container: classes.container
        }}
        hideHover
        label={header}
        description={description}
      >
        <div className={classes.close}>
          <IconButton {...iconProps} />
        </div>
        <div className={classes.action} style={{ maxWidth: 100 }}>
          {buttonNode}
        </div>
      </GridCell>
    );
  }
};

export default EntitlementUpgradePrompt;
